import React, { ReactNode } from 'react';

interface ComparisonCardProps {
  title: string;
  titleClassName?: string;
  bgClassName?: string;
  children: ReactNode;
}

const ComparisonCard: React.FC<ComparisonCardProps> = ({ 
  title, 
  titleClassName = "text-gray-700",
  bgClassName = "bg-white",
  children 
}) => (
  <div className={`${bgClassName} p-8 rounded-lg shadow-md`}>
    <h3 className={`text-xl font-bold mb-4 ${titleClassName}`}>{title}</h3>
    {children}
  </div>
);

export default ComparisonCard; 